import { createEsignT, type EsignTextKey } from '~/composables/esign/useEsignT'
import en from '~/locales/esign/en.json'

/** Maps a public API error code (contracts/esign/error-codes.json) to signer-facing copy. */
export function errorCopy(code: string | undefined, details?: Record<string, unknown>, translator = createEsignT()): string {
  const { t, tc } = translator
  if (!code) return t('error.generic')
  if (code === 'NETWORK') return t('error.network')
  if (code === 'INVALID_CODE') return tc('error.INVALID_CODE', Number(details?.attemptsLeft ?? 0))
  const key = `error.${code}`
  return key in en ? t(key as EsignTextKey) : t('error.generic')
}
